__turbopack_context__.v({
  "accessColumn": "ConnectionsTable-module__Z8DLmq__accessColumn",
  "appColumn": "ConnectionsTable-module__Z8DLmq__appColumn",
  "connectionsTable": "ConnectionsTable-module__Z8DLmq__connectionsTable",
  "countColumn": "ConnectionsTable-module__Z8DLmq__countColumn",
  "countColumnLabel": "ConnectionsTable-module__Z8DLmq__countColumnLabel",
  "lastModifiedColumn": "ConnectionsTable-module__Z8DLmq__lastModifiedColumn",
  "statusColumn": "ConnectionsTable-module__Z8DLmq__statusColumn",
});
